import config from '../config';
import { SendEmailRequest, SendEmailResponse } from '../models/Email';

interface ApiProblemDetails {
  detail?: string;
}

const postToEmailApi = async (path: string, payload: unknown): Promise<SendEmailResponse> => {
  const apiUrl = config.emailApiUrl;

  if (!apiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const response = await fetch(`${apiUrl}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => undefined)) as ApiProblemDetails | undefined;
    throw new Error(errorBody?.detail ?? `API responded with status ${response.status}`);
  }

  return (await response.json()) as SendEmailResponse;
};

export const sendEmail = async (payload: SendEmailRequest): Promise<SendEmailResponse> => postToEmailApi('', payload);
